import { adminFeatureSwitchSchema, type AdminFeatureSwitch } from '@steado/admin-contract/feature-switches';
import { queryOptions } from '@tanstack/react-query';
import { z } from 'zod';

import type { ApiClient } from '@/lib/api/client';

export function featureSwitchesQueryOptions(api: ApiClient) {
  return queryOptions({
    queryKey: ['admin', 'feature-switches'],
    queryFn: (): Promise<AdminFeatureSwitch[]> =>
      api.request({ path: '/admin/feature-switches', schema: z.array(adminFeatureSwitchSchema) }),
  });
}

/** The key is the confirmation: the dialog only sends once it has been typed. */
export function setFeatureSwitch(
  api: ApiClient,
  item: AdminFeatureSwitch,
  enabled: boolean,
): Promise<AdminFeatureSwitch> {
  return api.request({
    path: `/admin/feature-switches/${item.key}`,
    method: 'PUT',
    body: { enabled, confirmation: item.key },
    schema: adminFeatureSwitchSchema,
  });
}
